<template>
	<v-col class="ma-0 pa-0 pl-3 pr-3" cols="12" id="head_title">
		<v-row class="ma-0 pa-0" align="center" id="header_height">
      <v-col class="ma-0 pa-0" cols="auto" v-if="groupId == undefined">
			  <router-link :to="{ path: '/store-search' }"
			  	style="color:transparent;">
			  	<v-col class="ma-0 pa-0" cols="auto" align="center"
			  		style="color:#08B0FF;font-size:1rem;text-align:center;">
            {{t('top')}}
          </v-col>
        </router-link>
      </v-col>
      <v-col class="ma-0 pa-0" cols="auto" v-else>
        <router-link :to="{ path: '/store-group/detail?groupId=' + groupId }" style="color:transparent;">
			  	<v-col class="ma-0 pa-0" cols="auto" align="center"
			  		style="color:#08B0FF;font-size:1rem;text-align:center;">
            {{groupName}}
          </v-col>
        </router-link>
      </v-col>
			<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3" v-if="groupId == undefined"
				src="@/assets/images/history_arrow.png"></v-img>
      <v-col class="ma-0 pa-0" cols="auto" v-if="groupId == undefined">
        <router-link :to="{ path: '/store-search/detail' }"
			  	style="color:transparent;">
			  	<v-col class="ma-0 pa-0" cols="auto" align="center"
			  		style="color:#08B0FF;font-size:1rem;text-align:center;">
            {{tsc('searchResult')}}
          </v-col>
        </router-link>
      </v-col>
			<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
				src="@/assets/images/history_arrow.png"></v-img>
			<v-col class="ma-0 pa-0" cols="auto">
				{{storeData.customerName}}
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
    storeData: {},
    shareUserDialogVisible: false,
    groupId: undefined,
    groupName: '',
	}),
	created() {
		this.unisCustomerCd = this.$route.query.unisCustomerCd;
    this.storeData = this.$store.getters.getStoreData;
    if(this.$route.query.groupId != undefined) {
      this.groupId = this.$route.query.groupId;
      let currentGroupIndex = this.$store.state.userData.storeGroupList.findIndex(item => item.id == this.groupId);
      if(currentGroupIndex != -1) {
        this.groupName = this.$store.state.userData.storeGroupList[currentGroupIndex].groupName;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
#head_title {
	position: sticky;
	top: 0;
	z-index: 5;
}
</style>